import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface ClearBrokerAgreementButtonProps {
    brokerAgreementId: number | undefined;
    onClear: () => void;
    disabled: boolean;
}

/** Removes the chosen B-Client agreement, so another can be picked; hidden while there's none. */
export const ClearBrokerAgreementButton = ({ brokerAgreementId, onClear, disabled }: ClearBrokerAgreementButtonProps) => {
    if (!brokerAgreementId) {
        return null;
    }

    return (
        <IconButton
            id='borrowerBrokerAgreementClear'
            theme={IconButtonTheme.DarkBlueActive}
            size={IconButtonSize.ExtraSmall}
            icon={faTimes}
            hint='Remove selected Broker Agreement'
            disabled={disabled}
            handleClick={onClear}
        />
    );
};
